const actions = {
  SET_STATE: 'county/SET_STATE',
  REFRESH_ERRORS: 'county/REFRESH_ERRORS',
  ALL: 'county/ALL',
  FETCH_ALL: 'county/FETCH_ALL',
  DETAILS: 'county/DETAILS',
  ADD: 'county/ADD',
  EDIT: 'county/EDIT',
  REMOVE: 'county/REMOVE'
};

export default actions
